<template>
  <div class="classLearing edit-style">
    <!-- {{ classNum }} -->
    <div class="navigation">
      <van-icon name="arrow-left" size="24" @click="downView" />
      <p class="title">班级考点</p>
      <img src="@/assets/learning/setting.png" alt="" @click="toSetting" />
    </div>
    <div class="header-box">
      <div class="sort-box">
        <div
          v-for="v in sortList"
          :key="v.val"
          class="sort-list"
          :class="{ on: v.click }"
          @click="sortClick(v)"
        >
          {{ v.name }}
        </div>
      </div>
    </div>
    <knowledge
      v-if="keyType && sortList.filter((item) => item.click)[0].val == 1"
      :search-data="searchData"
    ></knowledge>
    <overview
      v-if="keyType && sortList.filter((item) => item.click)[0].val == 2"
      :search-data="searchData"
    ></overview>
    <wrongQuestion
      v-if="keyType && sortList.filter((item) => item.click)[0].val == 3"
      :search-data="searchData"
    ></wrongQuestion>
  </div>
</template>

<script>
import knowledge from "@/components/learning/knowledge";
import overview from "@/components/learning/overview";
import wrongQuestion from "@/components/learning/wrongQuestion";
// import { subjectOptions } from "@/util/constdata";
import {
  getGradelist,
  classlistbygrade,
  subjectlistbygradeandclassnum,
} from "@/api/interface";
export default {
  name: "ClassLearing",
  components: {
    knowledge,
    overview,
    wrongQuestion,
  },
  data() {
    return {
      subjectOptions: [],
      sortList: [
        { name: "知识点", val: 1, click: false },
        { name: "概况", val: 2, click: false },
        { name: "错题", val: 3, click: false },
      ],
      searchData: {
        subjectId: "",
        timeRange: 0,
        gradeId: 0,
      },
      keyType: false,
      knowledList: [],
      classNum: [],
      current: 0,
      apiData: {},
    };
  },
  created() {
    this.getPhoneType();
  },
  mounted() {
    let type = this.$route.query.isWeb;
    // console.log("11111111111");
    if (type) {
      if (this.$route.query.token) {
        this.$store.commit("setToken", this.$route.query.token);
        this.$store.commit("setSchoolId", this.$route.query.schoolID);
      }
      this.apiData.gradeId = this.$route.query.gradeId;
      this.apiData.classNum = this.$route.query.classNum;
      this.init();
    } else {
      window.initView = this.initView;
      window.goBackView = this.goBackView;
      this.initMobile();
    }
  },
  methods: {
    getPhoneType() {
      let u = navigator.userAgent;
      // this.isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //android终端
      this.isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
    },
    downWindow() {
      if (this.isiOS) {
        window.webkit.messageHandlers.commonCall.postMessage({
          type: 3,
        });
      } else {
        // return;
        window.mobile.hideTitleBar();
      }
    },
    goBackView() {
      this.downView();
    },
    initMobile() {
      if (this.isiOS) {
        window.webkit.messageHandlers.commonCall.postMessage({
          type: 2,
        });
      } else {
        window.mobile.initMobile();
      }
    },
    initView(data) {
      this.apiData = data;
      this.$store.commit("setToken", data.token);
      this.$store.commit("setSchoolId", data.schoolID);
      this.init();
      this.downWindow();
      // this.msg = msg;
    },
    downView() {
      if (this.isiOS) {
        window.webkit.messageHandlers.commonCall.postMessage({
          type: 1,
        });
      } else {
        window.mobile.closeMobileUI();
      }
    },
    init() {
      this.sortList[0].click = true;
      Object.assign(this.searchData, this.apiData);
      if (this.$route.query.gradeId) {
        Object.assign(this.searchData, this.$route.query);
      }

      if (this.searchData.gradeId) {
        this.getClassList();
      } else {
        this.getOption();
      }
    },
    toSetting() {
      let data = JSON.parse(JSON.stringify(this.searchData));
      if (this.$route.query.isWeb) {
        data.isWeb = true;
      }
      data.path = this.$route.name;
      data.urlType = "class";
      delete data.current;
      delete data.size;
      delete data.token;
      delete data.schoolID;
      this.$store.commit("delKeepArr");
      this.$router.push({
        name: "SettingLearning",
        query: data,
      });
    },
    subjectlistbygradeandclassnum() {
      if (this.searchData.subjectId) {
        this.setType();
        return;
      }
      let data = {
        classNum: this.searchData.classNum,
        gradeId: this.searchData.gradeId,
      };
      subjectlistbygradeandclassnum(data).then((res) => {
        this.subjectOptions = res.data;
        this.searchData.subjectId = this.subjectOptions[0].id;
        this.setType();
      });
    },
    setType() {
      // console.log(this.searchData);
      this.keyType = true;
    },
    getOption() {
      // let data = {
      //   token: this.apiData.token,
      //   schoolID: this.apiData.schoolID
      // };
      getGradelist().then((res) => {
        this.searchData.gradeId = res.data[0].id;
        this.getClassList();
      });
    },
    getClassList() {
      if (this.searchData.classNum) {
        this.subjectlistbygradeandclassnum();
        return;
      }
      let data = {
        token: this.apiData.token,
        schoolID: this.apiData.schoolID,
        gradeId: this.searchData.gradeId,
      };
      classlistbygrade(data).then((res) => {
        // this.classNum = res.data;
        this.searchData.classNum = res.data[0].classNum;
        this.subjectlistbygradeandclassnum();
      });
    },
    sortClick(v) {
      this.sortList.forEach((i) => {
        i.click = false;
      });
      v.click = true;
    },
  },
};
</script>

<style scoped lang="scss">
.classLearing {
}
</style>
